// @ts-nocheck - TODO: properly type this file!

// Work is in progress on this file
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useToken } from '@/common/helper';
import { useSpin } from '@/components/SpinContext.jsx';
import { CustomShipmentText } from '@/components';
import {
  useFetchAlertThresholds,
  useFetchCompanyCouriers,
  useUnAuthorize,
  useFetchLocations,
  useFetchProducts,
} from '@/hooks';
import {
  AlertFieldByType,
  AlertFooter,
  AlertRecipientSelector,
  NotifyViaPills,
  TriggerTypeCard,
  NotificationFrequency,
} from '@/pages/Shipments/PerShipmentNotification/components';
import { Flex, Form, Divider, message } from 'antd';
import {
  GxPReportEventOptions,
  NotificationApplyOptions,
  notificationsTriggerType,
} from '../../../common/static_data';
import { NotificationFilterApply } from './components';
import { useEffect, useCallback, useState, useRef } from 'react';
import { getTeamsDDLOFFeature } from '@/common/utils';
import { GetUsersByTeamIds } from '../../../apis/settings';
import { SendNotification } from '@/apis/onboarding';
import dayjs from 'dayjs';
import { getApplyConfig } from './NotificationConfig';
import RecipientValidationField from '@/pages/Shipments/PerShipmentNotification/components/RecipientValidationField';
import { InventoryDetails } from '@/pages/Inventory/components/InventoryDetailDrawer';
import { GetSingleInventoryDetailById } from '@/apis/inventory';

interface ApiResponse<T = any> {
  data: {
    data: {
      is_success: boolean;
      data: T[] | T;
      message: string;
    };
  };
}

function isArrayOfObjects<T = any>(arr: unknown): arr is T[] {
  if (!arr) {
    return;
  }
  return (
    Array.isArray(arr) &&
    arr.every(
      (item) =>
        typeof item === 'object' && item !== null && !Array.isArray(item)
    )
  );
}

const CreateNotification = ({
  step,
  setStep,
  onClose,
  drawerOpen,
  selected,
  isInventory = false,

  onSuccess = () => {},
  selecteInventoryID,
}) => {
  const { showSpin, hideSpin } = useSpin();
  const { locations } = useFetchLocations();
  const { products } = useFetchProducts();
  const { couriers } = useFetchCompanyCouriers();
  const [form] = Form.useForm();
  const [alertType, setAlertType] = useState(
    isInventory
      ? notificationsTriggerType?.[5].id
      : notificationsTriggerType?.[0].id
  );
  const [selectAllAlertTypes, setSelectAllAlertTypes] = useState(false);
  const [recipientsValues, setRecipientsValues] = useState([]);
  const [notificationMethod, setNotificationMethod] = useState('');
  const { checkTokenExpiry, token, decodedUserToken } = useToken();
  const loggedInUserId = decodedUserToken()?.email;
  const { unauthorize } = useUnAuthorize();
  const [recipient, setRecipient] = useState(null);
  const { alertThreshold, isLoading } = useFetchAlertThresholds(null);
  const [selectedThresholdValues, setSelectedThresholdValues] = useState({});
  const [selectedFrequency, setSelectedFrequency] = useState('REALTIME');
  const [teams, setTeams] = useState([]);
  const [teamsList, setTeamsList] = useState([]);
  const [applyType, setApplyType] = useState([]);
  const [allApplyType, setAllApplyType] = useState(false);
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [additional, setAdditional] = useState([]);
  const allGxPReportEvents = GxPReportEventOptions.map((event) =>
    event.value.toLowerCase()
  );

  const normalizeGxPEvents = (events = []) =>
    (Array.isArray(events) ? events : []).map((event) =>
      typeof event === 'string' ? event.toLowerCase() : event
    );

  const normalizeGxPEventsForForm = (events = []) =>
    (Array.isArray(events) ? events : []).map((event) =>
      typeof event === 'string' ? event.toUpperCase() : event
    );

  const [isRecipientsDropdownOpen, setIsRecipientsDropdownOpen] =
    useState(false);
  const [selectedFrequencyOption, setSelectedFrequencyOption] =
    useState('REALTIME');

  const [inventoryDetails, setInventoryDetails] = useState<InventoryDetails>(
    {} as InventoryDetails
  );

  const getUsersByTeams = useCallback(() => {
    GetUsersByTeamIds(token, [])
      .then((res: ApiResponse) => {
        const data = res?.data?.data;
        if (data.is_success) {
          setRecipient(data?.data);
        } else {
          setRecipient([]);
        }
      })
      .catch((error) => {
        unauthorize(error);
      });
  }, [token, unauthorize]);

  const enableNoTeams = useCallback((alertTypeValue, aiActionType) => {
    setTeamsList((prevTeams) => {
      let teamsArr = [...prevTeams];

      if (teamsArr.length > 0) {
        teamsArr = teamsArr.filter((x) => x.id !== 'no_team');

        if (alertTypeValue === 'AI_ACTION' && aiActionType === 1) {
          teamsArr.push({ id: 'no_team', name: 'No Teams' });
        }
      }

      return teamsArr;
    });
  }, []);

  const resetStates = useCallback(() => {
    setNotificationMethod('');
    setSelectedThresholdValues({});
    setTeams([]);
    form.resetFields();
    setSelectedFrequencyOption('REALTIME');
    setSelectedFrequency('REALTIME');
    setSelectAllAlertTypes(false);
  }, [form]);

  useEffect(() => {
    getUsersByTeams();
  }, [token, unauthorize, getUsersByTeams]);

  useEffect(() => {
    if (drawerOpen && !selected) {
      setStep(1);
      setAlertType(
        isInventory
          ? notificationsTriggerType[5]?.id
          : notificationsTriggerType?.[0].id
      );
      resetStates();
    }
  }, [drawerOpen, resetStates, selected, setStep, isInventory, setAlertType]);
  useEffect(() => {
    if (!selected) return;
    const mapping = [
      { key: 'filter_origins', stateKey: 'select_all_origins', type: 3 },
      {
        key: 'filter_destinations',
        stateKey: 'select_all_destinations',
        type: 4,
      },
      { key: 'filter_teams', stateKey: 'select_all_teams', type: 5 },
      {
        key: 'filter_transport_providers',
        stateKey: 'select_all_transport_providers',
        type: 2,
      },
      { key: 'products', stateKey: 'select_all_products', type: 1 },
    ];

    const types = mapping
      .filter(
        ({ key, stateKey }) =>
          selected?.[key]?.length > 0 || selected?.[stateKey]
      )
      .map(({ type }) => type);

    setApplyType(types);
  }, [selected, setApplyType]);

  const hasInitialized = useRef(false);

  //this major useEffect is for patcing values , to the form
  useEffect(() => {
    if (!selected || hasInitialized.current) return;
    hasInitialized.current = true;
    const normalizedLocation =
      selected?.location != null
        ? {
            value: selected.location,
            label: selected.location_name,
          }
        : null;
    form.setFieldsValue({
      location: normalizedLocation,
    });

    form.setFieldsValue({
      additional_recipients: selected?.additional_recipients,
      alert_type: selected?.alert_type,
      alert_types: selected?.alert_types,
      change_by: selected?.change_by,
      day: selected?.day,
      frequency: selected?.frequency,
      id: selected?.id,
      is_at_risk: selected?.is_at_risk,
      is_critical: selected?.is_critical,
      is_delivery_confirmation: selected?.is_delivery_confirmation,
      is_delivery_exception: selected?.is_delivery_exception,
      is_pickup_confirmation: selected?.is_pickup_confirmation,
      is_created: selected?.is_created,
      is_incomplete: selected?.is_incomplete,
      is_sent: selected?.is_sent,
      ai_action_type: selected.ai_action_type,
      // location: selected?.location,
      notification_method: selected?.notification_method,
      send_to: selected?.send_to,
      teams: selected?.teams,
      filter_origins: selected?.filter_origins?.map((item) => item.id),
      filter_destinations: selected?.filter_destinations?.map(
        (item) => item.id
      ),
      filter_teams: selected?.filter_teams?.map((item) => item.id),
      filter_transport_providers: selected?.filter_transport_providers?.map(
        (item) => item.id
      ),
      products: selected?.products?.map((item) => item.id),
      select_all_teams: selected?.select_all_teams ?? false,
      select_all_origins: selected?.select_all_origins ?? false,
      select_all_products: selected?.select_all_products ?? false,
      select_all_transport_providers:
        selected?.select_all_transport_providers ?? false,
      select_all_destinations: selected?.select_all_destinations ?? false,
      time_1: selected?.time_1 ? dayjs(selected.time_1, 'h:mm a') : null,
      time_2: selected?.time_2 ? dayjs(selected.time_2, 'h:mm a') : null,
      users: selected?.users,
      locations:
        selected?.locations?.map((loc) => ({
          value: loc.id,
          label: loc.name,
        })) || [],
      item:
        selected?.item?.map((loc) => ({
          value: loc.id,
          label: loc.name,
        })) || [],
      gxp_report: normalizeGxPEventsForForm(selected?.gxp_report_events),
    });
    enableNoTeams(selected?.alert_type, selected.ai_action_type);
    setAlertType(selected?.alert_type);
    setSelectAllAlertTypes(selected?.select_all_alert_types);
    setNotificationMethod(selected?.notification_method);
    if (selected?.alert_types) {
      setSelectedThresholdValues(selected?.alert_types);
      setStep(2);
    }
    // Normalize send_to to support both legacy (array) and new ({ teams_users, additional }) shapes
    const recepientsArr = [];
    const formValues = [];
    const teamsUsers = Array.isArray(selected?.send_to?.teams_users)
      ? selected?.send_to?.teams_users
      : [];
    teamsUsers.forEach((element) => {
      const obj = JSON.parse(JSON.stringify(element));
      const teamData = teams.find((t) => t.id === element?.id);
      if (element.select_all) {
        if (teamData) {
          teamData.select_all = true;
        }
        if (teamData?.users?.length > 0) {
          teamData.users.forEach((user) => {
            user.is_checked = true;
          });
        }
        const id = `${element.id}::ALL_MEMBERS`;
        recepientsArr.push(id);
        obj.users = [];
      } else {
        if (element?.users?.length > 0) {
          const userIds = [];
          element.users.forEach((user) => {
            const id = `${element.id}::${user?.id}`;
            userIds.push(user.id);
            if (teamData?.users?.length > 0) {
              teamData.users.forEach((u) => {
                if (u.id === user.id) {
                  u.is_checked = true;
                }
              });
            }
            recepientsArr.push(id);
          });
          obj.users = userIds;
        }
      }
      formValues.push(obj);
    });
    const additionalKeys = (
      Array.isArray(selected?.send_to?.additional)
        ? selected.send_to.additional
        : []
    )
      .filter((a) => a.enabled !== false)
      .map((a) => a.key);

    const values = [...recepientsArr, ...additionalKeys];
    setSelectedRecipients(values);
    setAdditional(additionalKeys);
    setRecipientsValues(formValues);
    setSelectedFrequency(selected?.frequency || 'REALTIME');
    setSelectedFrequencyOption(
      selected?.frequency !== 'REALTIME' ? 'digest' : selected?.frequency
    );
  }, [selected, form, setStep, teams, enableNoTeams]);

  useEffect(() => {
    getTeamsDDLOFFeature(
      token,
      isInventory ? 'Inventory' : 'ShipmentNotification'
    ).then((val) => {
      if (val && val.length > 0) setTeamsList(val);
    });
  }, [token, setTeamsList, isInventory]);

  const aiActionType = Form.useWatch('ai_action_type', form);

  useEffect(() => {
    enableNoTeams(alertType, aiActionType);
  }, [alertType, aiActionType, enableNoTeams]);

  const handleTeamsData = (data) => {
    setTeams(data);
  };

  const applyConfig = getApplyConfig({
    teamsList,
    origins: locations,
    products,
    couriers,
    destinations: locations,
  });

  // Uses each category's own "select all" flag instead of inferring "all"
  // from the category count, which used to wipe out manual per-category picks.
  const handleApplyAllCase = (values) => {
    const model = {};
    Object.keys(applyConfig).forEach((key) => {
      const cfg = applyConfig[key];
      const isActive = applyType.includes(Number(key));
      const isAll = isActive && Boolean(form.getFieldValue(cfg.stateKey));
      if (isAll) {
        model[cfg.key] = cfg?.list?.map(cfg.getId) || [];
        model[cfg.stateKey] = true;
      } else {
        model[cfg.key] = isActive ? values?.[cfg.key] || [] : [];
        model[cfg.stateKey] = false;
      }
    });
    return model;
  };

  const FrequencyToRealTime = () => {
    setSelectedFrequency('REALTIME');
    setSelectedFrequencyOption('REALTIME');
    form.setFieldsValue({
      time_1: null,
      time_2: null,
      frequency: null,
      day: '',
    });
  };

  const handleResetOnNotificationMethodChange = (val) => {
    if (val) {
      form.setFieldsValue({ users: null });
      setSelectedRecipients([]);
      setRecipientsValues([]);
      setAdditional([]);
      if (teams.length > 0) {
        teams.forEach((element) => {
          element.select_all = false;
          if (element?.users?.length > 0) {
            element.users.forEach((user) => {
              user.is_checked = false;
            });
          }
        });
      }
      if (val !== 'EMAIL' && val !== 'SLACK' && val !== 'TEAMS') {
        FrequencyToRealTime();
      }
    }
  };

  useEffect(() => {
    if (!selected) return;
    const mapping = [
      { key: 'filter_origins', type: 3 },
      { key: 'filter_destinations', type: 4 },
      { key: 'filter_teams', type: 5 },
      { key: 'filter_transport_providers', type: 2 },
      { key: 'products', type: 1 },
    ];

    const types = mapping
      .filter(({ key }) => selected?.[key]?.length > 0)
      .map(({ type }) => type);
    setAllApplyType(types.length === NotificationApplyOptions.length);
    setApplyType(types);
  }, [selected, setApplyType]);

  const handleAlertType = (val) => {
    setAlertType(val);
    //setNotificationMethod('');
    setSelectedThresholdValues({});
    form.setFieldsValue({
      change_by: null,
      gxp_report: null,
      locations: null,
      is_pickup_confirmation: false,
      is_delivery_exception: false,
      is_delivery_confirmation: false,
      is_created: false,
      is_incomplete: false,
    });
    setSelectAllAlertTypes(false);
    if (val === 'AI_ACTION') {
      FrequencyToRealTime();
    }
  };

  const handleSubmit = (values) => {
    let keys = Object.keys(selectedThresholdValues ?? {});
    const sendTo = recipientsValues;
    let model = {
      ...values,
      location: values?.location?.value,
      time_1: values.time_1?.format('h:mm a'),
      time_2: values.time_2?.format('h:mm a'),
      alert_type: alertType,
      send_to: sendTo,
      alert_types: selectedThresholdValues,
      frequency: selectedFrequency,
      select_all_alert_types: selectAllAlertTypes,
      additional_recipients: additional,
    };
    model = { ...model, ...handleApplyAllCase(values) };
    if (alertType === 'TEMPERATURE_GXP') {
      const gxpReportEvents = normalizeGxPEvents(values?.gxp_report);
      model.gxp_report_events = gxpReportEvents;
      model.select_all_gxp_report_events =
        gxpReportEvents.length === allGxPReportEvents.length &&
        allGxPReportEvents.every((event) => gxpReportEvents.includes(event));
      delete model.gxp_report;
    }
    if (selected && selected?.id) {
      if (model?.locations && isArrayOfObjects(model?.locations)) {
        model.locations = model.locations.map((x) => x?.value);
      }
      if (model?.item && isArrayOfObjects(model?.item)) {
        model.item = model.item.map((x) => x?.value);
      }
      model.id = selected?.id;
    }
    if (
      alertType === 'CRITICAL_ALERT' &&
      (!selectedThresholdValues ||
        Object.keys(selectedThresholdValues).length === 0)
    ) {
      let allThresholds = {};
      alertThreshold?.forEach((element) => {
        element?.alerts.forEach((ele) => {
          allThresholds = {
            ...allThresholds,
            [ele.alert_type]: ele.threshold_value,
          };
        });
      });
      model.alert_types = allThresholds;
      keys = Object.keys(allThresholds ?? {});
      model.select_all_alert_types = Object.keys(allThresholds)?.length > 0;
    }

    const isCritical = keys?.some((key) =>
      ['temperature_excursion_detected', 'viability_window_exhausted'].includes(
        key
      )
    );
    const isAtrisk =
      keys?.length > 0 &&
      !keys?.every((key) =>
        [
          'temperature_excursion_detected',
          'viability_window_exhausted',
        ].includes(key)
      );
    model.is_at_risk = isAtrisk;
    model.is_critical = isCritical;
    delete model?.users;

    const token = checkTokenExpiry();
    showSpin();
    SendNotification(token, model)
      .then((res: ApiResponse) => {
        const data = res?.data || null;
        if (data?.data?.is_success) {
          message.success(data?.data?.message);
          onClose();
          onSuccess();
        } else {
          message.error(data?.data?.message);
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const fetchInventoryDetails = useCallback(
    async (id: string) => {
      try {
        showSpin();
        const res = await GetSingleInventoryDetailById(id, token);
        const data = res?.data?.data?.data ?? null;
        setInventoryDetails(data);
      } catch (error) {
        unauthorize(error);
      } finally {
        hideSpin();
      }
    },
    [showSpin, hideSpin, unauthorize, token]
  );

  useEffect(() => {
    if (selecteInventoryID) {
      fetchInventoryDetails(selecteInventoryID);
    }
  }, [fetchInventoryDetails, selecteInventoryID]);
  const isLowInventorySelected = alertType === 'LOW_INVENTORY';
  return (
    <>
      <Form form={form} onFinish={handleSubmit} layout='vertical'>
        <Flex
          vertical
          gap={16}
          style={{ marginTop: '-16px', paddingBottom: '125px' }}
        >
          <CustomShipmentText
            text={step === 3 ? 'Add alert type' : 'Notification'}
            fontSize='20px'
            lineHeight='28px'
            fontWeight={700}
          />
          {step !== 3 && (
            <TriggerTypeCard
              setAlertType={handleAlertType}
              selected={selected}
              notificationsTriggerType={notificationsTriggerType}
              isSidePannel={true}
              isInventory={isInventory}
            />
          )}
          <AlertFieldByType
            step={step}
            setStep={setStep}
            form={form}
            alertType={alertType}
            shipment={null}
            selectAllAlertTypes={selectAllAlertTypes}
            setSelectAllAlertTypes={setSelectAllAlertTypes}
            alertThreshold={alertThreshold}
            setSelectedThresholdValues={setSelectedThresholdValues}
            selectedThresholdValues={selectedThresholdValues}
            maxHeight={'100%'}
            showThresholdInputSection={false}
            enableAllThresholds={true}
            shipmentTeams={[]}
            isInventory={isInventory}
            selecteInventory={inventoryDetails}
            isLoading={isLoading}
          />
          {step !== 3 && (
            <>
              {!isLowInventorySelected && (
                <>
                  <Divider className='notification-divider' />
                  <NotificationFilterApply
                    allApplyType={allApplyType}
                    applyType={applyType}
                    setApplyType={setApplyType}
                    form={form}
                    applyConfig={applyConfig}
                  />
                </>
              )}
              <Divider className='notification-divider' />
              <NotifyViaPills
                form={form}
                notificationType='non-ai'
                setNotificationMethod={setNotificationMethod}
                resetOnChange={handleResetOnNotificationMethodChange}
                alertType={alertType}
              />
              <RecipientValidationField
                form={form}
                selectedRecipients={selectedRecipients}
              >
                <AlertRecipientSelector
                  alertType={alertType}
                  isRecipientsDropdownOpen={isRecipientsDropdownOpen}
                  loggedInUserId={loggedInUserId}
                  form={form}
                  recipientData={recipient}
                  setIsRecipientsDropdownOpen={setIsRecipientsDropdownOpen}
                  sendTeamsToParent={handleTeamsData}
                  notificationMethod={notificationMethod}
                  showAdditionalTP={false}
                  selectedRecipients={selectedRecipients}
                  setSelectedRecipients={setSelectedRecipients}
                  setRecipientsValues={setRecipientsValues}
                  setAdditional={setAdditional}
                  recipientsValues={recipientsValues}
                />
              </RecipientValidationField>
              <NotificationFrequency
                form={form}
                selectedFrequencyOption={selectedFrequencyOption}
                setSelectedFrequencyOption={setSelectedFrequencyOption}
                selectedFrequency={selectedFrequency}
                setSelectedFrequency={setSelectedFrequency}
                notificationMethod={notificationMethod}
                alertType={alertType}
              />
            </>
          )}
        </Flex>
        <AlertFooter
          step={step}
          setStep={setStep}
          setOpenNotificationModal={onClose}
          isSidePannel={true}
          text={'Enable notification'}
        />
      </Form>
    </>
  );
};

export default CreateNotification;
